import { gql } from '@apollo/client';

export const DASHBOARD_FUNDS = gql`
  query getFunds($input: FilterArgs) {
    spentAmount(input: $input)
    budgetedAmount(input: $input)
    receivedAmount(input: $input)
  }
`;
